<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/rfq"
          :class="getRoute() === 'rfq' ? 'active' : ''"
          navText="Request For Quotation"
        >
          <template v-slot:icon>
            <i
              class="ni ni-single-copy-04 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/purchase-order"
          :class="getRoute() === 'purchase-order' ? 'active' : ''"
          navText="Purchase Order"
        >
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/tender"
          :class="getRoute() === 'tender' ? 'active' : ''"
          navText="Tender"
        >
          <template v-slot:icon>
            <i class="fa fa-rss text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/request-for-proposal"
          :class="getRoute() === 'request-for-proposal' ? 'active' : ''"
          navText="Request for Proposal"
        >
          <template v-slot:icon>
            <i class="fa fa-money text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/vendor-bill"
          :class="getRoute() === 'vendor-bill' ? 'active' : ''"
          navText="Vendor Bills"
        >
          <template v-slot:icon>
            <i class="fa fa-file-invoice text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase fw-bolder opacity-6 ms-2"
        >
          ACCOUNT PAGES
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          navText="Profile"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <a href="#" class="nav-link" @click="logout">
          <div
            class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-sign-out text-danger text-sm opacity-10"></i>
          </div>
          <span
            class="nav-link-text ms-1'"
            >Sign Out</span
          >
        </a>
      </li>
    </ul>
  </div>
  <!-- <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div> -->
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
// import SidenavCard from "./SidenavCard.vue";
const endpoint = require("../../router/endpoint");

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  components: {
    SidenavItem,
    // SidenavCard
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout() {
      this.axios
      .post(endpoint.SIGN_OUT, {
        partner_id: parseInt(localStorage.getItem('partner_id')),
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
        .then(response => {
          if (response.data.msg_status === '0000') {
            this.$store.dispatch('setLoginState', false)
            localStorage.removeItem('isLogin')
            localStorage.removeItem('token')
            localStorage.removeItem('name')
            localStorage.removeItem('partner_id')
            localStorage.removeItem('partner_code')
            localStorage.removeItem('partner_vat')
            localStorage.removeItem('allowed_extensions')
            localStorage.removeItem('limit_file')
            localStorage.removeItem('is_pkp')

            this.$router.replace('/signin')
          }
          else {
            this.$notify({
              type: 'warn',
              title: 'Warning!',
              text: response.data.message
            });
          }
        })
        .catch(e => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
        })
    }
  }
};
</script>
